import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { name } from '@azure/msal-angular/packageMetadata';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
//import { RelativeDateParserService } from '../../services/relative-date-parser.service';

@Component({
  selector: 'app-time-period',
  templateUrl: './time-period.component.html',
  styleUrls: ['./time-period.component.css']
})
export class TimePeriodComponent implements OnInit {
  @ViewChild('helpModal', { static: false }) helpModal: ModalDirective;

  @Input() period: string = "today";
  @Output() periodChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() type: string;
  @Input() size: string = "md";

  displayName:string = "Today";
  selectedItem: any;
  templateItems:any = [
    {name:"Today",value:"today"},
    {name:"Yesterday",value:"yesterday"},
    {name:"This Week",value:"thisWeek"},
    {name:"Last Week",value:"lastWeek"},
    {name:"This Month",value:"thisMonth"},
    {name:"Last Month",value:"lastMonth"},
    {name:"This Year",value:"thisYear"},
    {name:"Last Year",value:"lastYear"},
    {name:"Latest",value:"latest"},
  ];

  from: string;
  to: string;
  fromDate: string;
  toDate: string;
  fromType: string;
  toType: string;
  dateTimeFormat: string = "yyyy-MM-dd H:mm:ss";
  dateTimeInvalid: boolean = false;
  bsConfig: any = {dateInputFormat: 'YYYY-MM-DD', containerClass: "theme-default"};

  constructor() {
    this.type = "template";
  }

  ngOnInit() {
    this.selectedItem = this.templateItems[0];
  }

  selectTemplate(template){
    this.selectedItem = template;
    this.displayName = this.selectedItem.name;
    this.period = this.selectedItem.value;
    this.type = "template";
    this.change();
  }

  change() : void {
    if (this.periodChange) {
      this.periodChange.emit(this.period);
    }
  }

  changeRelative(): void {
      if (this.from && this.fromType && this.to && this.toType) {
          this.period = this.from + this.fromType + ":" + this.to + this.toType;
          this.change();
      }
  }

  changeDates(which: number): void {
    this.selectedItem = null;
    if (this.fromDate && this.toDate) {
      //let before = this.getDateString(this.fromDate) + "," + this.getDateString(this.toDate);
      /*if (which == 0){
          // make sure to is after from
          if (Date.parse(this.toDate) <= Date.parse(this.fromDate)){
              this.toDate = (Date.parse(this.fromDate) + 1).toString();
          }
      } else {
          // make sure from is before to
          if (Date.parse(this.toDate) <= Date.parse(this.fromDate)){
              this.fromDate = (Date.parse(this.toDate) - 1).toString();
          }
      }*/
      
      //todo: limit date range to 6 months


      this.period = this.getDateString(new Date(Date.parse(this.fromDate))) + "," + this.getDateString(new Date(Date.parse(this.toDate)));
      if (Date.parse(this.fromDate) < Date.parse(this.toDate)){
        this.dateTimeInvalid = false;
        this.change();
      }else{
        this.dateTimeInvalid = true;
      }
    }
  }

  appendLeadingZeroes(n): string {
    if(n <= 9){
      return "0" + n;
    }
    return n
  }


  getDateString(current_datetime: Date): string{
    let formatted_date = current_datetime.getFullYear() + "-" + this.appendLeadingZeroes(current_datetime.getMonth() + 1) + "-" + this.appendLeadingZeroes(current_datetime.getDate()) + " " 
      + "00:00:00"
      //+ this.appendLeadingZeroes(current_datetime.getHours()) + ":" + this.appendLeadingZeroes(current_datetime.getMinutes()) + ":" + this.appendLeadingZeroes(current_datetime.getSeconds())
    
    return formatted_date;
  }

  /**
   * Open the customer modal
   */
   openHelpModal(): void {
    this.helpModal.show();
  }

  /**
   * Close the customer modal, resets create/edit logic.
   */
  closeHelpModal(): void {
    this.helpModal.hide();
  }

}
